export default __webpack_public_path__ + "static/media/photo--sm--misc-23.188cd6da.jpg";